/*
 * Where a result row's HL7 document comes from (KIN-2096 / KIN-2120).
 *
 * The inbox list used to return every message's full raw HL7 in `rawXml` on every row —
 * every patient's demographics, identifiers and results, on every page load, whether or
 * not anyone opened the row. The backend is dropping it from the list, so the document
 * is fetched for the one row that was opened instead.
 *
 * `rawXml` is still read when the list sends it, so this ships safely either side of
 * that backend change.
 *
 * The stylesheet is unchanged: `item.xsl`, which normalizeResultsResponse resolves from
 * the list's shared `xsls` array. Without one there is nothing to render the document
 * with, so there is nothing to fetch it for either.
 */
export const resolveResultHl7Document = ({ item, fetched, isFetching } = {}) => {
  const inlineXml = item?.rawXml || null;
  const xsl = item?.xsl || null;
  const messageControlId = item?.messageId || null;

  const shouldFetch = !inlineXml && !!xsl && !!messageControlId;
  const xml = inlineXml || fetched?.xmlContent || null;

  return {
    messageControlId,
    shouldFetch,
    isLoading: shouldFetch && !!isFetching,
    xml,
    xsl,
    hasPreview: !!xml && !!xsl,
  };
};
